import React, { Component } from 'react'
import SuperUserLoanPageUI from './SuperUserLoanPageUI.js'

class SuperUserLoanPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      more: false
    }
  }

  render() {
    return (
      <SuperUserLoanPageUI
        context={this.props.context}
        className={this.props.className}
        backLink={this.props.backLink}
        headerText={this.props.headerText}
        dimension={this.props.dimension}
        centered={this.props.centered}
        children={this.props.children}
        loan={this.props.loan}
        page={this.props.page}
        more={this.state.more}
        onMore={() => { console.log('here'); this.setState({ more: true }) }}
      />
    )
  }

  componentDidUpdate1(prevProps) {
    let loan = this.props.loan
    if (!loan)
      return
    if (prevProps.loan && prevProps.loan.loanId == loan.loanId)
      return

    this.setState({
      more: false,
    })
  }

  componentDidMount() {
  }
}

export default SuperUserLoanPageSF
